import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { scrollToHashWhenReady } from '@/assets/js/Common/scrollToHash'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  },
  {
    path: '/About',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/Schedule',
    name: 'schedule',
    component: () => import(/* webpackChunkName: "schedule" */ '../components/Terminal/TerminalSchedule.vue')
  },
  {
    path: '/EmptyContainer',
    name: 'emptyContainer',
    component: () => import(/* webpackChunkName: "emptyContainer" */ '../components/Terminal/EmptyContainer.vue')
  },
  {
    path: '/EmptyInTime',
    name: 'emptyInTime',
    component: () => import(/* webpackChunkName: "emptyInTime" */ '../components/Terminal/EmptyInTime.vue')
  },
  {
    path: '/YardWorkStatus',
    name: 'yardWorkStatus',
    component: () => import(/* webpackChunkName: "yardWorkStatus" */ '../components/Terminal/YardWorkStatus.vue')
  },
  {
    path: '/VesselWorkStatus',
    name: 'vesselWorkStatus',
    component: () => import(/* webpackChunkName: "vesselWorkStatus" */ '../components/Terminal/VesselWorkStatus.vue')
  },
  {
    path: '/Vessel',
    name: 'vessel',
    component: () => import(/* webpackChunkName: "vessel" */ '../components/Terminal/TerminalVessel.vue')
  },
  {
    path: '/CopinoSend',
    name: 'CopinoSend',
    component: () => import(/* webpackChunkName: "CopinoSend" */ '../components/Terminal/CopinoSend.vue')
  },
  {
    path: '/CopinoSend/:searchType/:searchData',
    name: 'copinoSend',
    component: () => import(/* webpackChunkName: "copinoSend" */ '../components/Terminal/CopinoSend.vue')
  },
  {
    path: '/Container/:contNo',
    name: 'container',
    component: () => import(/* webpackChunkName: "container" */ '../components/Terminal/TerminalContainer.vue')
  },
  {
    path: '/Container',
    name: 'Container',
    component: () => import(/* webpackChunkName: "Container" */ '../components/Terminal/TerminalContainer.vue')
  },
  {
    path: '/FAQ',
    name: 'faq',
    component: () => import(/* webpackChunkName: "faq" */ '../components/Support/SupportFAQ.vue')
  },
  {
    path: '/Notice/:searchSelect/:searchKeyword',
    name: 'notice',
    component: () => import(/* webpackChunkName: "notice" */ '../components/Support/SupportNotice.vue')
  },
  {
    path: '/Tender/:searchSelect/:searchKeyword',
    name: 'tender',
    component: () => import(/* webpackChunkName: "tender" */ '../components/Support/SupportTender.vue')
  },
  {
    path: '/Recruit/:searchSelect/:searchKeyword',
    name: 'recruit',
    component: () => import(/* webpackChunkName: "recruit" */ '../components/Support/SupportRecruit.vue')
  },
  {
    path: '/Reference/:searchSelect/:searchKeyword',
    name: 'reference',
    component: () => import(/* webpackChunkName: "reference" */ '../components/Support/SupportReference.vue')
  },
  {
    path: '/Notice/:searchSelect',
    name: 'Notice',
    component: () => import(/* webpackChunkName: "notice" */ '../components/Support/SupportNotice.vue')
  },
  {
    path: '/Tender/:searchSelect',
    name: 'Tender',
    component: () => import(/* webpackChunkName: "tender" */ '../components/Support/SupportTender.vue')
  },
  {
    path: '/Recruit/:searchSelect',
    name: 'Recruit',
    component: () => import(/* webpackChunkName: "recruit" */ '../components/Support/SupportRecruit.vue')
  },
  {
    path: '/Reference/:searchSelect',
    name: 'Reference',
    component: () => import(/* webpackChunkName: "reference" */ '../components/Support/SupportReference.vue')
  },
  {
    path: '/Detail/:commNo/:commCode',
    name: 'detail',
    component: () => import(/* webpackChunkName: "detail" */ '../components/Support/SupportDetail.vue')
  },
  {
    path: '/Ethicalmanagement',
    name: 'ethicalmanagement',
    component: () => import(/* webpackChunkName: "report" */ '../components/Support/SupportEthical.vue')
  },
  {
    path: '/Privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "report" */ '../components/Support/SupportPrivacy.vue')
  },
  {
    path: '/Contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../components/Support/SupportContact.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return new Promise((resolve) => {
        const tryScroll = (attempt = 0) => {
          const id = to.hash === '#ict' ? 'AboutICT' : to.hash.replace(/^#/, '')
          if (!document.getElementById(id) && attempt < 40) {
            setTimeout(() => tryScroll(attempt + 1), 50)
            return
          }
          scrollToHashWhenReady(to.hash).then(() => resolve(false))
        }
        tryScroll()
      })
    }
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const nextPath = to.fullPath

  router.onError((error) => {
    console.error(error)
    if (error.name === 'ChunkLoadError') {
      window.location.href = nextPath || '/'
    }
  })

  next()
})

export default router
